import { basicUIPlugin } from '@stackflow/plugin-basic-ui'
import '@stackflow/plugin-basic-ui/index.css'
import { basicRendererPlugin } from '@stackflow/plugin-renderer-basic'
import { stackflow } from '@stackflow/react'
import { GetServerSideProps } from 'next'
import { useMemo } from 'react'
import BlogDetailActivity from '../../../../components/webview/blog/BlogDetailActivity'
import BlogMainAcitivity from '../../../../components/webview/blog/BlogMainAcitivity'

const activities = {
  BlogMainAcitivity,
  BlogDetailActivity,
}

export type BlogActivityNamesType = keyof typeof activities

export const useBlogStack = (initialActivityName?: string | string[], initialParams?) => {
  const {
    Stack: BlogStack,
    useFlow: useBlogFlow,
    activities: BlogActivities,
  } = useMemo(() => {
    return stackflow({
      transitionDuration: 350,
      activities: activities,
      plugins: [
        basicRendererPlugin(),
        basicUIPlugin({
          theme: 'cupertino',
        }),
        () => {
          return {
            key: 'blog-param-nested-navigation-plugin',
            overrideInitialEvents: ({ initialEvents }) => {
              const temp = {
                ...initialEvents[0],
                activityName: initialActivityName as BlogActivityNamesType,
                activityParams: initialParams,
              }
              return [temp]
            },
          }
        },
      ],
      initialActivity: () => initialActivityName as BlogActivityNamesType,
    })
  }, [initialActivityName])

  return { BlogStack, BlogActivities, useBlogFlow }
}

const Index = ({ activity, slug }) => {
  console.log(activity, slug, ' activity, slug  activity, slug  activity, slug ')
  const { BlogStack, BlogActivities } = useBlogStack(activity, { slug: slug })

  console.log(BlogActivities, 'BlogActivities')

  return (
    <div className="h-full w-full ">
      <BlogStack />
    </div>
  )
}

export const getServerSideProps: GetServerSideProps = async (props) => {
  const { query } = props
  const { activity = 'BlogMainAcitivity', slug = '' } = query
  return {
    props: {
      activity: activity,
      slug: slug,
    },
  }
}

export default Index
